import React from 'react';
import Select from 'react-select';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Helmet } from 'react-helmet';

import ContentWrapper from '../components/contentWrapper/contentWrapper';
import { ReactComponent as DecorationChip } from '../images/svgs/write-to-lj-chip-pink.svg';
import { ReactComponent as DecoStrips } from '../images/svgs/deco-strips.svg';

import { ReactComponent as BlueCircleDots } from '../images/svgs/pink-circle-dots.svg';

import styles from '../styles/pagesComponents/messageLJPage.module.scss';

const MessageLJPage = ({ intl }) => {
  const options = [
    {
      value: intl.formatMessage({ id: 'contact.category1' }),
      label: intl.formatMessage({ id: 'contact.label.category1' }),
    },
    {
      value: intl.formatMessage({ id: 'contact.category2' }),
      label: intl.formatMessage({ id: 'contact.label.category2' }),
    },
    {
      value: intl.formatMessage({ id: 'contact.category3' }),
      label: intl.formatMessage({ id: 'contact.label.category3' }),
    },
  ];

  const selectStyles = {
    control: (baseStyles) => ({
      ...baseStyles,
      border: `2px solid ${styles.themePrimaryOutline}`,
      borderRadius: '2rem',
      '&:hover': {
        borderColor: styles.themePrimary,
      },
      boxShadow: 'none',
    }),
    container: (baseStyles) => ({
      ...baseStyles,
      marginBottom: '3rem',
    }),
    valueContainer: (baseStyles) => ({
      ...baseStyles,
      padding: '0.7rem',
    }),
  };

  return (
    <ContentWrapper isPageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: 'menu.messageLJ' })}</title>
        <meta
          name="description"
          content={intl.formatMessage({ id: 'meta.description.messageLJ' })}
        />
        <meta
          property="og:title"
          content={intl.formatMessage({ id: 'menu.messageLJ' })}
        />
        <meta
          property="og:description"
          content={intl.formatMessage({ id: 'meta.description.messageLJ' })}
        />
      </Helmet>
      <div className={styles.container}>
        <div className={styles.coverContainer}>
          <div className={styles.dotsContainer}>
            <BlueCircleDots />
          </div>
          <div className={styles.stripsContainer}>
            <DecoStrips />
          </div>
          <div className={styles.titleContainer}>
            <h2 className={styles.header}>
              <FormattedMessage id="menu.messageLJ" />
            </h2>
          </div>
          <div className={styles.chipContainer}>
            <DecorationChip />
          </div>
        </div>
        <div className={styles.content}>
          <form
            className={styles.form}
            name="contact"
            method="POST"
            data-netlify="true"
            netlify-honeypot="bot-field"
            netlify
          >
            <label htmlFor="name">
              <FormattedMessage id="contact.name" />
            </label>
            <input
              className={styles.input}
              type="text"
              name="name"
              id="name"
              required
            />
            <label htmlFor="number">
              <FormattedMessage id="contact.number" />
            </label>
            <input
              className={styles.input}
              type="number"
              name="number"
              id="number"
            />
            <label htmlFor="email">
              <FormattedMessage id="contact.email" />
            </label>
            <input
              className={styles.input}
              type="email"
              name="email"
              id="email"
              required
            />
            <label htmlFor="category">
              <FormattedMessage id="contact.category" />
            </label>
            <Select
              options={options}
              styles={selectStyles}
              placeholder={intl.formatMessage({ id: 'contact.select' })}
            />
            <label htmlFor="message">
              <FormattedMessage id="contact.message" />
            </label>
            <textarea name="message" id="message" rows={10} required />
            <div data-netlify-recaptcha />
            <input type="hidden" name="form-name" value="contact" />
            <div className={styles.hidden}>
              <label htmlFor="bot-field">Only for robots</label>
              <input type="text" name="bot-field" id="bot-field" />
            </div>
            <div className={styles.buttonContainer}>
              <button type="submit">
                <FormattedMessage id="contact.submit" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </ContentWrapper>
  );
};

MessageLJPage.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(MessageLJPage);
